import { useDispatch, useSelector } from 'react-redux';

import { redeemedCodeSelector, shoppingCartSelector } from '~screens/Dashboard/screens/Home/redux/selectors';
import { actionCreators as homeActions } from '~screens/Dashboard/screens/Home/redux/actions';
import { getShoppingCartTotal } from '~models/shoppingCart';

import { getGiftCardBalancesComponents, getNextBalance } from './utils';

export const useGiftCardBalance = () => {
  const dispatch = useDispatch();
  const shoppingCart = useSelector(shoppingCartSelector);
  const redeemedCode = useSelector(redeemedCodeSelector);
  const { amount: currentBalance, useGiftCard, isGiftCard } = redeemedCode;

  const giftCardBalancesComponents = getGiftCardBalancesComponents({
    currentBalance,
    nextBalance: getNextBalance(currentBalance, getShoppingCartTotal(shoppingCart)),
    useGiftCard
  });

  const setUseGiftCard = () =>
    dispatch(homeActions.redeemCode({ ...redeemedCode, useGiftCard: !useGiftCard }));

  return {
    currentBalance,
    useGiftCard,
    isGiftCard,
    setUseGiftCard,
    giftCardBalancesComponents
  };
};
